<template>
  <div class="header">
    <div class="header_top container_wrap clearfloat">
      <div class="fl headerLeft">
        <router-link to="/"
          >
          <img class="logoImgIco" src="../assets/logo_jl.jpg" alt=""/>
          <img class="logoImg" src="../assets/logo_05.png" alt=""/>
        </router-link>
      </div>
      <div class="headerRight fr">
        <el-input
          placeholder="请输入搜索内容"
          v-model="input"
          class="input-with-select"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="search"
          ></el-button>
        </el-input>
      </div>
    </div>

    <div class="nav_box">
      <div class="container_wrap">
        <ul class="clearfloat">
          <li :class="{ active: active == 1 }">
            <h2><router-link to="/">首页</router-link></h2>
          </li>
          <li
            :class="{ active: active == 2 }"
            @mouseenter="navShow('navShow01')"
            @mouseleave="navClose('navShow01')"
          >
            <h2><router-link to="/about">关于我们</router-link></h2>
            <el-collapse-transition>
              <div class="nav_down" v-show="navShow01">
                <p><router-link to="/about">公司简介</router-link></p>
                <p><router-link to="/about/organ">组织架构</router-link></p>
                <p><router-link to="/team">管理团队</router-link></p>
                <p><router-link to="/about/invite">招贤纳士</router-link></p>
              </div>
            </el-collapse-transition>
          </li>
          <li
            :class="{ active: active == 3 }"
            @mouseenter="navShow('navShow02')"
            @mouseleave="navClose('navShow02')"
          >
            <h2><router-link to="/company">企业优势</router-link></h2>
            <el-collapse-transition>
              <div class="nav_down" v-show="navShow02">
                <p><router-link to="/company">企业资质</router-link></p>
                <p><router-link to="/company/honor">企业荣誉</router-link></p>
                <!-- <p><router-link to="/company/team">管理团队</router-link></p> -->
              </div>
            </el-collapse-transition>
          </li>
          <!-- <li
           :class="{'active':active == 4}"
           @mouseenter="navShow('navShow03')"
           @mouseleave="navClose('navShow03')"
          >
            <h2><router-link to="/culture">企业文化</router-link></h2>
          </li> -->
          <li
            :class="{ active: active == 4 }"
            @mouseenter="navShow('navShow03')"
            @mouseleave="navClose('navShow03')"
          >
            <h2><router-link to="/sever">服务领域</router-link></h2>
            <el-collapse-transition>
              <div class="nav_down" v-show="navShow03">
                <p v-for="(item, index) in navSever" :key="index">
                  <router-link :to="'/sever?id=' + item.id">{{
                    item.title
                  }}</router-link>
                </p>
              </div>
            </el-collapse-transition>
          </li>
          <!-- <li
           :class="{'active':active == 8}"
           @mouseenter="navShow('navShow06')"
           @mouseleave="navClose('navShow06')"
          >
            <h2><router-link to="/sever">党的建设</router-link></h2>
            <el-collapse-transition>
              <div class="nav_down" v-show="navShow06">
                <p v-for="(item, index) in navDdjs" :key="index">
                  <router-link :to="'/search?id='+ item.id">{{ item.name }}</router-link>
                </p>
              </div>
            </el-collapse-transition>
          </li> -->
          <li :class="{ active: active == 8 }">
            <h2><router-link to="/search?id=13">党的建设</router-link></h2>
          </li>
          <li
            :class="{ active: active == 5 }"
            @mouseenter="navShow('navShow04')"
            @mouseleave="navClose('navShow04')"
          >
            <h2><router-link to="/news">新闻资讯</router-link></h2>
            <el-collapse-transition>
              <div class="nav_down" v-show="navShow04">
                <p><router-link to="/news">集团动态</router-link></p>
                <p><router-link to="/news/bases">公司动态</router-link></p>
                <p><router-link to="/news/notice">基层动态</router-link></p>
              </div>
            </el-collapse-transition>
          </li>
          <li
            :class="{ active: active == 6 }"
            @mouseenter="navShow('navShow05')"
            @mouseleave="navClose('navShow05')"
          >
            <h2><router-link to="/policy">政策规范</router-link></h2>
            <el-collapse-transition>
              <div class="nav_down" v-show="navShow05">
                <p><router-link to="/policy">国家政策</router-link></p>
                <p><router-link to="/policy/local">地方法规</router-link></p>
                <p><router-link to="/books">电子书屋</router-link></p>
                <!-- <p><router-link to="/policy/industry">行业规范</router-link></p>
                <p><router-link to="/policy/common">通用表式</router-link></p> -->
              </div>
            </el-collapse-transition>
          </li>
          <li :class="{ active: active == 7 }">
            <h2><router-link to="/contact">联系我们</router-link></h2>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  components: {},
  data() {
    return {
      active: "1",
      input: "",
      navSever: [],
      navDdjs: [],
      navShow01: false,
      navShow02: false,
      navShow03: false,
      navShow04: false,
      navShow05: false,
      navShow06: false,
    };
  },
  mounted: function () {},
  created: function () {
    var _this = this;

    _this.active = _this.$route.meta ? _this.$route.meta.text : "1";
    if (_this.$route.fullPath == "/search?id=13") {
      _this.active = 8;
    }
    _this.getSeverNav();
    _this.getDdjsNav();
  },
  methods: {
    // 二级导航展开
    navShow(d) {
      let _this = this;
      _this[d] = true;
    },
    // 二级导航收起
    navClose(d) {
      let _this = this;
      _this[d] = false;
    },
    // 搜索
    search() {
      var _this = this;
      if (_this.input.match(/^\s*$/)) {
        this.$message({
          message: "请输入搜索内容",
          type: "warning",
        });
      } else {
        window.location.href = "/search?title=" + _this.input;
      }
    },
    // 服务领域-nav
    async getSeverNav() {
      var _this = this;
      var { data } = await _this.$http.post(
        _this.apiUrl + "/serve/getServeList",
        { classification: 20000 }
      );
      if (data.code == 200) {
        _this.navSever = data.data;
      }
    },
    // 党的建设-nav
    async getDdjsNav() {
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + "/getTopic");
      if (data.code == 200) {
        _this.navDdjs = data.data;
      }
    },
  },
  watch: {
    $route: function () {
      this.active = this.$route.meta ? this.$route.meta.text : "1";
      if (this.$route.fullPath == "/search?id=13") {
        this.active = 8;
      }
    },
  },
};
</script>

<style scoped>
.header {
  /* background-color: #ededed; */
  background-color: #fff;
}
.header_top {
  padding: 20px 0;
}
.headerLeft {
  line-height: 60px;
  font-size: 0;
}
.headerLeft .logoImgIco {
  height: 54px;
  width: auto;
  margin-right: 0px;
  margin-top: -2px;
  vertical-align: middle;
}
.headerLeft .logoImg {
  
}
.headerRight {
  margin-top: 10px;
}
.nav_box {
  height: 68px;
  background-color: #1970b9;
  line-height: 68px;
}

.nav_box ul li {
  float: left;
  /* width: 14.28%;  */
  width: 12.5%;
  color: #fff;
  text-align: center;
  position: relative;
}
.nav_box ul li a {
  display: block;
}
.nav_box ul li h2 {
  font-size: 18px;
  font-weight: bolder;
}
.nav_box ul li h2 a {
  border-right: 1px solid #1970b9;
  color: #fff;
}
.nav_box ul li:hover h2 a {
  color: #1970b9;
  background-color: #b1c7e0;
  font-weight: 600;
}
.nav_box ul li.active h2 a {
  color: #1970b9;
  background-color: #b1c7e0;
  font-weight: 600;
}
.nav_down {
  position: absolute;
  width: 100%;
  left: 0;
  top: 68px;
  z-index: 55;
}
.nav_down p {
  line-height: 50px;
  border-top: 1px solid #fff;
}
.nav_down p a {
  color: #333;
  background-color: #d6e0eb;
}
.nav_down p a:hover {
  color: #1970b9;
}
</style>